export default __webpack_public_path__ + "static/arrow-down-ad0d84cfd4c486501c1b460374b3f1f9.svg";